// Shared Google review data — used by the homepage reviews marquee and the
// /testimonials page. Keep this as the single source of truth so the two
// surfaces never drift apart (and we don't get duplicate / mismatched copies).
const GOOGLE_REVIEWS = [
  {
    quote: "This is easily one of the best companies I've ever had the pleasure of doing business with. Ryan did an incredible job.",
    author: 'Abelardo Ramos',
    role: '2 reviews • 0 photos',
    source: 'Google',
    timeago: '3 weeks ago'
  },
  {
    quote: 'Got my website up and running quickly! Very smooth process and experience overall. Thanks!!',
    author: 'Briana Guzman',
    role: '15 reviews • 3 photos',
    source: 'Google',
    timeago: '3 weeks ago'
  },
  {
    quote: 'Beau & Ryan at Versa have created me the most incredible website to showcase my art! I am so so grateful!',
    author: 'Maggie Torchia',
    role: '5 reviews • 1 photo',
    source: 'Google',
    timeago: '4 weeks ago'
  },
  {
    quote: 'Versa Launch were super professional and responded to my request faster than 4 other agencies I reached out to.',
    author: 'Dylan Fraser',
    role: '4 reviews • 0 photos',
    source: 'Google',
    timeago: '4 weeks ago'
  },
  {
    quote: 'Incredibly fast! Extremely helpful and welcoming :)',
    author: 'Emma Dwyer',
    role: '9 reviews • 0 photos',
    source: 'Google',
    timeago: '4 weeks ago'
  },
  {
    quote: 'Great service! Website is perfect!',
    author: 'Jackson Geurts',
    role: '7 reviews • 0 photos',
    source: 'Google',
    timeago: '4 weeks ago'
  },
  {
    quote: "I am so very grateful to this company. Thanks to Ryan for helping me with my website - it's now easier for anybody to find me.",
    author: 'Aaron',
    role: '3 reviews • 0 photos',
    source: 'Google',
    timeago: '4 weeks ago'
  },
  {
    quote: 'Very insightful and creative people to work with. Thank you for getting us situated and making our complex ideas come to life!',
    author: 'Josh Doyle',
    role: '1 review • 0 photos',
    source: 'Google',
    timeago: '4 weeks ago'
  },
  {
    quote: 'I was referred by a friend and hands down would refer Versa Launch to any business owner I know. Easy to work with and reliable!',
    author: 'Ian Tornel',
    role: '11 reviews • 0 photos',
    source: 'Google',
    timeago: '4 weeks ago'
  },
  {
    quote: 'I was very impressed with the team. They delivered quality results with great customer service.',
    author: 'Hanne Funk',
    role: '8 reviews • 0 photos',
    source: 'Google',
    timeago: '4 weeks ago'
  },
  {
    quote: 'Amazing customer service from beginning to end. I would highly recommend them to anyone. Quality of work is amazing as well! 10/10.',
    author: 'Jacquez Coleman',
    role: '1 review • 0 photos',
    source: 'Google',
    timeago: '4 weeks ago'
  },
  {
    quote: 'Versa got my website up and running better than ever before! I was thoroughly impressed with the results. Thank you!',
    author: 'Vanessa Asencio',
    role: '1 review • 0 photos',
    source: 'Google',
    timeago: '13 weeks ago'
  },
  {
    quote: "Mike was very helpful when it came to getting my website exposure. It's easy to use and I have watched my traffic increase tenfold! Definitely recommend!",
    author: 'Rachael Slack',
    role: '1 review • 0 photos',
    source: 'Google',
    timeago: '13 weeks ago'
  },
  {
    quote: 'Best company to work with. The entire staff is professional and eager to help your business grow.',
    author: 'Austin Nash',
    role: '3 reviews • 0 photos',
    source: 'Google',
    timeago: '13 weeks ago'
  },
  {
    quote: "Best quality in service I've had in a long time.",
    author: 'John Berli',
    role: '3 reviews • 0 photos',
    source: 'Google',
    timeago: '13 weeks ago'
  },
  {
    quote: 'Thank you! Beau is amazing!',
    author: 'Caleb Strickland',
    role: '4 reviews • 1 photo',
    source: 'Google',
    timeago: '13 weeks ago'
  },
  {
    quote: "Amazing service, thanks boys - I'll be back!",
    author: 'Ant Ling',
    role: '4 reviews • 0 photos',
    source: 'Google',
    timeago: '13 weeks ago'
  },
  {
    quote: 'Thank you! Beau was awesome!',
    author: 'Payten Cornelius',
    role: '2 reviews • 0 photos',
    source: 'Google',
    timeago: '13 weeks ago'
  },
  {
    quote: 'Mike chatted with me after I told him I needed a website built for a small non-profit, and he and the guys gave me quick, easy service.',
    author: 'Alex Seidel',
    role: 'Local Guide • 13 reviews • 0 photos',
    source: 'Google',
    timeago: '13 weeks ago'
  },
  {
    quote: 'Mike chatted with me about getting a simple website set up for my coffee and bakery, and I was surprised they set up our whole site for us.',
    author: 'Brantley Keen',
    role: '6 reviews • 0 photos',
    source: 'Google',
    timeago: '13 weeks ago'
  },
  {
    quote: 'I had a great experience with these guys. They went above and beyond meeting my requests. I would recommend to anyone!',
    author: 'Nick Hancock',
    role: '1 review • 0 photos',
    source: 'Google',
    timeago: '13 weeks ago'
  },
  {
    quote: 'The website was so user friendly and I learned a lot about increasing revenue. Looking forward to seeing growth! Versa rocks and the people are exceptionally friendly and helpful.',
    author: 'Faith Moore',
    role: '8 reviews • 1 photo',
    source: 'Google',
    timeago: '14 weeks ago'
  },
  {
    quote: 'Versa knows how to do it!',
    author: 'Jake Tarabokija',
    role: '2 reviews • 0 photos',
    source: 'Google',
    timeago: '14 weeks ago'
  },
  {
    quote: 'Thank you guys for all of the help! You are awesome!',
    author: 'Jalyn Fullerton',
    role: '7 reviews • 0 photos',
    source: 'Google',
    timeago: '14 weeks ago'
  },
  {
    quote: "Amazing guys! They make sure you're happy with their service. They were very flexible with my schedule and made great suggestions!",
    author: 'jimbococo',
    role: '1 review • 0 photos',
    source: 'Google',
    timeago: '14 weeks ago'
  },
  {
    quote: 'Tailored and thoughtful expertise. Results already showing. Recommending to all my colleagues.',
    author: 'Joshua Belcher',
    role: '3 reviews • 0 photos',
    source: 'Google',
    timeago: '14 weeks ago'
  },
  {
    quote: 'Versa Launch is user-friendly and helped scale my website! The packages are fair and the sales team truly takes care of you and explained everything to me!',
    author: 'Kelly Rangeloff',
    role: '2 reviews • 0 photos',
    source: 'Google',
    timeago: '14 weeks ago'
  },
  {
    quote: 'Hands free, client friendly, and affordable.',
    author: 'Mike Smick',
    role: '10 reviews • 1 photo',
    source: 'Google',
    timeago: '14 weeks ago'
  },
  {
    quote: 'These people are amazing to work with. I felt like I was actually cared about with this team. Would recommend!',
    author: 'Hunter Yeomans',
    role: '4 reviews • 0 photos',
    source: 'Google',
    timeago: '14 weeks ago'
  },
  {
    quote: 'Would highly recommend!!!',
    author: 'Christian Upton',
    role: '4 reviews • 0 photos',
    source: 'Google',
    timeago: '15 weeks ago'
  },
  {
    quote: 'Super happy with my experience! The team built me a website (and even helped with an app) that turned out way better than expected.',
    author: 'Colby Strickland',
    role: '2 reviews • 0 photos',
    source: 'Google',
    timeago: '15 weeks ago'
  },
  {
    quote: 'Great to work with and exceptional work! Would 100% recommend.',
    author: 'Jayson Cabutto',
    role: '7 reviews • 0 photos',
    source: 'Google',
    timeago: '15 weeks ago'
  },
  {
    quote: 'The team was incredibly friendly and worked efficiently to get my website up and running. They delivered a much more polished site than I expected.',
    author: 'Lindsey Miller',
    role: '2 reviews • 0 photos',
    source: 'Google',
    timeago: '15 weeks ago'
  },
  {
    quote: 'Can always count on these guys.',
    author: 'Cody Miller',
    role: '4 reviews • 2 photos',
    source: 'Google',
    timeago: '15 weeks ago'
  },
  {
    quote: 'Amazing work, they are absolutely incredible and respond fast. Thank you guys! 😄',
    author: 'Jt Tillman',
    role: '7 reviews • 0 photos',
    source: 'Google',
    timeago: '15 weeks ago'
  },
  {
    quote: 'You have a vision? Versa Launch will help it come true.',
    author: 'Baye Beauford',
    role: '12 reviews • 3 photos',
    source: 'Google',
    timeago: '15 weeks ago'
  },
  {
    quote: 'For a strongheaded individual as myself, getting help was difficult already. Versa Launch made the request easy and straightforward.',
    author: 'Walter Cummings',
    role: 'Local Guide • 28 reviews • 3 photos',
    source: 'Google',
    timeago: '37 weeks ago'
  },
  {
    quote: 'Helped me design a website for a charitable organization and they literally had it up and running online by the end of the day.',
    author: 'JAG Miller',
    role: 'Local Guide • 13 reviews • 0 photos',
    source: 'Google',
    timeago: '38 weeks ago'
  },
  {
    quote: 'They really care about the details. My site looks amazing and works perfectly on both desktop and mobile.',
    author: 'Jason Cooper',
    role: '1 review • 0 photos',
    source: 'Google',
    timeago: '38 weeks ago'
  },
  {
    quote: 'Versa Launch completely transformed our online presence. Professional, fast, and affordable.',
    author: 'Hunter Danforth',
    role: '7 reviews • 0 photos',
    source: 'Google',
    timeago: '38 weeks ago'
  }
];

export default GOOGLE_REVIEWS;
